export const GET_EVENTS = 'GET_EVENTS';
export const REFRESH_EVENTS = 'REFRESH_EVENTS';
export const SET_EVENTS = 'SET_EVENTS';
export const UPDATE_EVENTS = 'UPDATE_EVENTS';
export const SCHEDULE_EVENT = 'SCHEDULE_EVENT';
export const FINISH_EVENT = 'FINISH_EVENT';
export const REMOVE_GUEST = 'REMOVE_GUEST';
